module.exports = __webpack_public_path__ + "img/4.d8ee7e69.gif";